import { render, staticRenderFns } from "./plugin_list_side.vue?vue&type=template&id=1f25a724&"
import script from "./plugin_list_side.vue?vue&type=script&lang=js&"
export * from "./plugin_list_side.vue?vue&type=script&lang=js&"
import style0 from "./plugin_list_side.vue?vue&type=style&index=0&id=1f25a724&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports